import { render, staticRenderFns } from "./AddPskovPrice.vue?vue&type=template&id=ad9dc518&scoped=true"
import script from "./AddPskovPrice.vue?vue&type=script&lang=js"
export * from "./AddPskovPrice.vue?vue&type=script&lang=js"
import style0 from "./AddPskovPrice.vue?vue&type=style&index=0&id=ad9dc518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9dc518",
  null
  
)

export default component.exports